const Statuses = [
  { code: 'CCD', label: 'Cancelled' },
  { code: 'DRF', label: 'Shipment Collected' },
  { code: 'SHC', label: 'Shipment Created' },
  { code: 'OND', label: 'Shipment On-hold' },
  { code: 'AWD', label: 'Awaiting drop-off' },
  { code: 'PU', label: 'Shipment Pick Up' },
  { code: 'SI', label: 'Shipment Inspection' },
  { code: 'WC', label: 'With Delivering Courier' },
  { code: 'BA', label: 'Incorrect Address' },
  { code: 'AR', label: 'Arrived Delivery Facility' },
  { code: 'DF', label: 'Departed Facility' },
  { code: 'DS', label: 'Destroyed / Disposal' },
  { code: 'RT', label: 'Returned to Consignor' },
  { code: 'AF', label: 'Arrived Facility' },
  { code: 'CR', label: 'Custom Release' },
  { code: 'RR', label: 'Custom Clearance' },
  { code: 'OH', label: 'On Hold' },
  { code: 'SD', label: 'Shipment Detail Received' },
  { code: 'SA', label: 'Shipment Accepted' },
  { code: 'FD', label: 'Transferred to 3rd Party' },
  { code: 'OK', label: 'Delivered' },
  { code: 'CC', label: 'Awaiting collection' },
  { code: 'PL', label: 'Processed' },
  { code: 'IN', label: 'In-transit' },
]

export default Statuses
